import sortBy from 'lodash/sortBy';

import styles from '../../styles/pages/index.module.scss';
import { getStoresList, getRegionsList } from '../api/cms';
import CustomMetaHead from '../components/CustomMetaHead';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Navigation from '../components/Navigation/Navigation';
import StoresLayout from '../components/StoresPage/StoresLayout';
import META_DATA from '../constants/metaData';
import { getOrFetchFooterLinks } from '../utils/footerLinks';
import { getOrFetchNavigationLinks } from '../utils/navigationLinks';

export default function Stores({ footerLinks, navigation, stores, regions, meta }) {
  return (
    <>
      <CustomMetaHead meta={meta} />
      <header className={styles.headerContainer}>
        <Header navigation={navigation} />
        <Navigation navigation={navigation} />
      </header>
      <StoresLayout stores={stores} regions={regions} />
      <Footer footerLinks={footerLinks} />
    </>
  );
}

export async function getStaticProps() {
  const [footerLinks, { data: navigation }, { data: stores }, { data: regionsFetched }] = await Promise.all([
    getOrFetchFooterLinks(),
    getOrFetchNavigationLinks(),
    getStoresList(),
    getRegionsList(),
  ]);

  const regions = sortBy(regionsFetched, 'title');
  const meta = META_DATA[process.env.appName].stores;

  return {
    props: { footerLinks, navigation, stores, regions, meta },
  };
}
